import { Loader } from '@grafikr/components';

import state from 'utils/state';

export default Loader(({ node }, load) => {
  const [key, value] = node.dataset.state.split(':');

  if (state.get(key) === value) {
    load();
  }

  return () => {};
});
